import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconWarning: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_18920_69953)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V11Z',
      })
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_18920_69953',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: 24,
          height: 24,
        })
      )
    )
  )
}
